/* oxlint-disable react/react-compiler -- Existing code is not yet compatible with React Compiler checks. */
import type { Site } from '@gitbook/api-client';
import { useConfigurationTheme } from '@gitbook/react-uikit';
import { Icon, type SVGIconProps } from '@gitbook/spine-icons';

import { ControlledContentIcon } from '../Content';

/**
 * Get the site icon component based on the site's publication status.
 */
export function getSiteIcon(site: Site) {
    return site.published ? Icon.DocsSite : Icon.DocsSiteUnpublished;
}

/**
 * Icon for a site with its publication status.
 */
export function SiteIcon({ site, ...props }: { site: Site } & SVGIconProps) {
    const IconComponent = getSiteIcon(site);
    return <IconComponent {...props} />;
}

/**
 * Icon for a site representing the icon used in the content.
 */
export function SiteContentIcon({
    site,
    withBackground = true,
    outlined = true,
    size,
    ...props
}: {
    /** Site to render an icon for. */
    site: Site;
    /** Icon size in pixels. */
    size?: number;
    /** Optional class name applied to the icon wrapper. */
    className?: string;
    /** Whether the icon should be rendered with a background. */
    withBackground?: boolean;
    /** Whether the icon should include a border and padding. */
    outlined?: boolean;
}) {
    const theme = useConfigurationTheme();
    const withOutlinedBackground = withBackground && outlined;

    if (site.icon && 'emoji' in site.icon) {
        return (
            <ControlledContentIcon
                emoji={site.icon.emoji}
                iconURL={undefined}
                fallbackText={site.title}
                withBackground={withOutlinedBackground}
                size={size}
                {...props}
            />
        );
    }
    if (site.icon && 'icon' in site.icon) {
        return (
            <ControlledContentIcon
                iconURL={site.icon.icon[theme.color]}
                emoji={undefined}
                withBackground={withOutlinedBackground}
                fallbackText={site.title}
                size={size}
                {...props}
            />
        );
    }
    return (
        <ControlledContentIcon
            iconURL={undefined}
            emoji={undefined}
            fallbackText={site.title}
            withBackground={withOutlinedBackground}
            size={size}
            {...props}
        />
    );
}
